import React, { FC } from 'react';

import { FontAwesomeIcon } from '@appcharge/shared-ui';

import { cn } from 'components/lib/utils';
import {
  Popover,
  PopoverContent,
  PopoverTrigger
} from 'components/ui/popover';

interface IDayCardProps {
  dayLabel: string;
  rewardCount: number;
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  children: React.ReactNode;
  footer?: React.ReactNode;
}

export const DayCard: FC<IDayCardProps> = ({
  dayLabel,
  rewardCount,
  isOpen,
  onOpenChange,
  children,
  footer
}) => (
  <Popover open={isOpen} onOpenChange={onOpenChange}>
    <PopoverTrigger asChild>
      <button
        type="button"
        className={cn(
          'flex flex-1 items-center justify-between h-8 py-2 px-3 rounded-md border bg-base-background text-p-s transition-colors',
          isOpen
            ? 'border-indigo-600'
            : 'border-base-input hover:bg-base-accent'
        )}
      >
        <span className="text-p-xs font-medium leading-none text-base-foreground">
          {dayLabel}
        </span>
        <span
          className={cn(
            'inline-flex items-center gap-1',
            rewardCount > 0 ? 'text-indigo-500' : 'text-base-mutedForeground'
          )}
        >
          <FontAwesomeIcon icon="fa-regular fa-gift" />
          <span>{rewardCount}</span>
        </span>
      </button>
    </PopoverTrigger>
    <PopoverContent
      align="start"
      side="bottom"
      sideOffset={8}
      className={cn(
        'w-[319px] rounded-[6px] border border-base-border bg-base-background p-6 [box-shadow:0_20px_25px_-5px_rgba(0,0,0,0.10),0_10px_10px_-5px_rgba(0,0,0,0.04)]',
        'flex min-h-0 max-h-[min(448px,calc(100dvh-5rem))] flex-col overflow-hidden'
      )}
    >
      <div className="flex min-h-0 min-w-0 w-full flex-1 flex-col gap-2 overflow-hidden">
        {children}
        {footer != null ? <div className="shrink-0">{footer}</div> : null}
      </div>
    </PopoverContent>
  </Popover>
);
